<template>
  <div>
    <secondHeader />
    <div class="main">
      <sidebar />
      <div class="content">

        <h2>
            <svg data-slot="icon" fill="none" stroke-width="1.5" width="22" hight="22" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M8.625 9.75a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 0 1 .778-.332 48.294 48.294 0 0 0 5.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"></path>
            </svg>
            アプデ情報
        </h2>
        <p class="news-description">はいしんツールキットの最新アプデ情報をまとめます。</p>
        <div class="news-item">
          <p class="news-date">2024/07/19</p>
          <h3 class="news-title">カウンターツールをリリースしました</h3>
          <p class="news-text">OBS用に簡単導入できる「カウンターツール」をリリースしました！<br>
            フォントや背景をカスタマイズでき、OBSにカウントボタンを設置できます。<br>
            配信で何かを数えたいときにピッタシです。
          </p>
          <div class="news-link-block">
            <a href="https://ruri.info/tool/counter" target="_blank" class="news-link">詳しくはこちら</a>
          </div>
        </div>

        <div class="news-item">
          <p class="news-date">2024/07/15</p>
          <h3 class="news-title">【コメントCSS】吹き出しの色を変更できるようになりました</h3>
          <p class="news-text">有料版の「ふきだしコメント」で背景色を変更できるようになりました！<br>
            とくに背景が白の配信画面にも合わせやすくなったのがポイントです！<br>
            🥝 すでにご購入の方は追加購入なしで使えます<br>
            🥝 カスタムページの内容を追記するだけでOK<br>
            🥝 詳細は商品同梱のReadmeに記載しています
          </p>
          <div class="news-link-block">
            <a href="https://ruri.info/tool/ytcomment" target="_blank" class="news-link">詳しくはこちら</a>
          </div>
        </div>

        <div class="news-item">
          <p class="news-date">2024/06/13</p>
          <h3 class="news-title">セットリスト管理ツール「セトリサン」リリース</h3>
          <p class="news-text">
            OBS用の「セトリ管理ツール」をリリースしました<br>
            用意した曲リストから、一曲ずつ表示できる便利なやつです。<br>
            操作もOBSだけですべて完結するので超スマート！<br>
            歌枠をよくする配信者さんにおすすめです。
          </p>
          <div class="news-link-block">
            <a href="https://takatsukisyou.booth.pm/items/5826705" target="_blank" class="news-link">詳しくはこちら</a>
          </div>
        </div>

        <div class="ad-block">
            <div class="ad">
              <InFeedAdsense
                  data-ad-layout-key="-fb+5w+4e-db+86"
                  data-ad-client="ca-pub-9016794589237931"
                  data-ad-slot="4898735474">
              </InFeedAdsense>
            </div>
          </div>
      </div>
    </div>

  </div>
</template>
<script>
import secondHeader from "../components/secondHeader.vue";
import sidebar from "../components/sidebar.vue"

export default {
  components: {
    secondHeader,
    sidebar,
  },
    data(){
      return{
        isProduction: process.env.NODE_ENV === "production",
      }
    }
};
</script>
<style scoped>
.main {
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  margin: 0 auto;
  background: linear-gradient(-225deg, #acb6e5 0%, #fff 25%,#fff 75%, #FFBAC3 100%);
}
.content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 60px 0 60px 1.82%;
  margin: 0 auto;
  margin: 0 auto;
  max-width: 767px;
}
.icon{
    height: 1.5rem;
    line-height: 1.5em;
    vertical-align: middle;
    margin-right: 6px;
}
h2 {
  border-bottom: solid 3px #cbcbcb;
  position: relative;
  letter-spacing: 1px;
  line-height: 1.5em
}

h2:after {
  position: absolute;
  content: " ";
  display: block;
  border-bottom: solid 3px #ffa4b0;
  bottom: -3px;
  width: 20%;
}

.news-description{
  font-size: 1.2rem;
  margin-bottom: 12px;
}
.news-item{
  margin-top: 24px;
  margin-bottom: 24px;
}
.news-date{
  font-size: 0.8rem;
  color: #555;
  font-weight: bold;
}
.news-title{
  font-size: 1.2rem;
  margin-top: 4px;
  margin-bottom: 12px;
  color: #ff94a0;
}
.news-text{
  font-size: 1rem;
  margin-bottom: 12px;
  color: #555;
  line-height: 1.5em;
}
.news-link-block{
  text-align: right;
}
.news-link{
  font-size: 0.8rem;
  color: #fff;
  background-color: #ffa4b0;
  text-decoration: none;
  padding: 4px 12px;
  border-radius: 4px;
  margin-bottom: 12px;
  display: inline-block;
  transition: background-color 0.3s;
}
.news-link:hover{
  background-color: #ff94a0;
}

.ad-block{
  padding: 24px 12px 0px 12px;
  display: block;
  width: 100%;
}
.ad {
  max-height: 300px;
  max-width: 70%;
  margin: 0 auto;
  text-align: center;
  box-sizing: border-box;
  display: block;
}
</style>